import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import './ResizableLayout.css'

const propTypes = {
  leftComponent: PropTypes.node.isRequired,
  rightComponent: PropTypes.node.isRequired,
  dividerDirection: PropTypes.oneOf(['left', 'right']),
  dividerPosition: PropTypes.number,
  minDividerPosition: PropTypes.number,
  maxDividerPosition: PropTypes.number,
  onDividerPositionChange: PropTypes.func,
}

const defaultProps = {
  dividerPosition: 320,
  dividerDirection: 'right',
  minDividerPosition: null,
  maxDividerPosition: null,
}

class ResizableLayout extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isDragging: false,
      dividerPosition: _.defaultTo(props.dividerPosition, defaultProps.dividerPosition),
    }

    this.containerRef = React.createRef()
  }

  componentWillReceiveProps(nextProps) {
    const { dividerPosition: currentDividerPosition } = this.props
    const { dividerPosition: nextDividerPosition } = nextProps

    if (!_.isEqual(currentDividerPosition, nextDividerPosition)) {
      this.setState({
        dividerPosition: nextDividerPosition,
      })
    }
  }

  handleMouseDown = () => {
    this.setState({ isDragging: true })

    document.addEventListener('mousemove', this.handleMouseMove)
    document.addEventListener('mouseup', this.handleMouseUp)
  }

  handleMouseMove = event => {
    if (!this.state.isDragging) {
      return
    }

    const { dividerDirection, minDividerPosition, maxDividerPosition, onDividerPositionChange } = this.props

    const container = this.containerRef.current
    const containerPosition = container.getBoundingClientRect()[dividerDirection]
    const eventPosition = _.isEqual(dividerDirection, 'right')
      ? containerPosition - event.clientX
      : event.clientX - containerPosition
    const defaultMinDividerPosition = _.defaultTo(minDividerPosition, 0)
    const defaultMaxDividerPosition = _.defaultTo(maxDividerPosition, container.offsetWidth) - defaultMinDividerPosition
    const dividerPosition = _.min([_.max([eventPosition, defaultMinDividerPosition]), defaultMaxDividerPosition])

    if (onDividerPositionChange) {
      onDividerPositionChange(dividerPosition)
    }
    this.setState({ dividerPosition })
  }

  handleMouseUp = () => {
    this.setState({ isDragging: false })

    document.removeEventListener('mousemove', this.handleMouseMove)
    document.removeEventListener('mouseup', this.handleMouseUp)
  }

  render() {
    const { leftComponent, rightComponent, dividerDirection } = this.props
    const { dividerPosition } = this.state

    const leftStyle = {}
    const dividerStyle = {}
    const rightStyle = {}

    switch (dividerDirection) {
      case 'left':
        leftStyle.width = dividerPosition
        dividerStyle.left = `calc(${dividerPosition}px - 0.125rem)`
        rightStyle.left = dividerPosition

        break
      case 'right':
      default:
        leftStyle.width = `calc(100% - ${dividerPosition}px)`
        dividerStyle.right = `calc(${dividerPosition}px - 0.125rem)`
        rightStyle.right = dividerPosition

        break
    }

    return (
      <div className="ResizableLayout" ref={this.containerRef}>
        <div className="ResizableLayout__Left" style={leftStyle}>
          {leftComponent}
        </div>

        <div className="ResizableLayout__Divider" style={dividerStyle} onMouseDown={this.handleMouseDown} />

        <div className="ResizableLayout__Right" style={rightStyle}>
          {rightComponent}
        </div>
      </div>
    )
  }
}

ResizableLayout.propTypes = propTypes
ResizableLayout.defaultProps = defaultProps

export default ResizableLayout
